module.exports = __webpack_public_path__ + "static/img/05.f590cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/05.jpg
// module id = 9WIC
// module chunks = 0